import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EmailConfig } from '../shared/tipos/interfaces';

@Injectable({
  providedIn: 'root'
})
export class SendEmailsService {

  // Substitua pela URL da sua API Gateway
  private apiUrl = ' https://jyvjzzt8b7.execute-api.eu-west-1.amazonaws.com/dev/email';

  constructor(private http: HttpClient) { }

  sendEmail(emailConfig: EmailConfig): Observable<any> {
    // Transformar o objeto em string JSON e colocar dentro de "body"
    const payload = {
      body: JSON.stringify({
        to: emailConfig.to,
        subject: emailConfig.subject,
        message: emailConfig.message
      })
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post(this.apiUrl, payload, { headers });
  }
}

